import React from 'react';
import {NavLink , Link} from 'react-router-dom';
import logo from '../../logo.png';
import NavItem from './NavItem';

const FixedNav=({scrollClasses})=>{

    return(
        <div className={scrollClasses}>
            <Link  to="/"><div className="fixed-logo"> <img src={logo} alt="fixed-logo"/></div></Link>
            <NavLink exact to="/" activeClassName="active" className="nav-item"><NavItem title="الرئيسية"/></NavLink>
            <NavLink to="/services" activeClassName="active" className="nav-item"><NavItem title="خدماتنا"/></NavLink>
            <NavLink to="/about" activeClassName="active" className="nav-item"><NavItem title="عن المركز"/></NavLink>
            <NavLink to="/contact" activeClassName="active" className="nav-item"><NavItem title="أتصل بنا"/></NavLink> 
        </div>
    );
}
export default FixedNav;


// WEBPACK FOOTER //
// ./src/components/nav/FixedNav.js